module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hometime Platform","short_name":"Hometime Platform","start_url":"/","background_color":"#07635A","theme_color":"#DCF6EA","display":"standalone","icon":"src/app-icons/favicon-32x32.png","legacy":true,"theme_color_in_head":false,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7bd0f412ba9efc4ed95fd8a17ba719ba"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
